import { render, staticRenderFns } from "./AppDetail.vue?vue&type=template&id=66724a25&scoped=true"
import script from "./AppDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./AppDetail.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AppDetail.vue?vue&type=style&index=0&id=66724a25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66724a25",
  null
  
)

export default component.exports